import { isAnywayPartner } from '~kui/components/KUI/Unified/Asset/assetCardSponsorship';

import type { ArticleCard } from '~/composables/unified/content/articleCards';

/**
 * Reports a click on an article card, so every page's article cards land in one event: which page
 * and section, and the card's 1-based place. A page can narrow `section` to its own sections.
 */
export const useArticleCardClick = <S extends string = string>(page: string) => {
  const analytics = useAnalyticsService();

  return (article: ArticleCard, section: S, index: number) => {
    analytics.track(EVENTS.UNIFIED_LEARN_IA_ARTICLES_CARD_CLICKED, {
      page,
      section,
      cardIndex: index + 1,
      articleId: article.id,
      articleSlug: article.slug,
      articleName: article.name,
      isSponsored: !!article.partnerName && !isAnywayPartner(article.partnerName),
    });
  };
};
